import * as Yup from 'yup';

export const formSchema = Yup.object({
  owner: Yup.object({
    uid: Yup.string().nullable(),
    agencyCommissionRate: Yup.number()
      .useNaNAsNull()
      .useNegativeZeroAsNegative()
      .min(0)
      .max(100),
    businessName: Yup.string(),
    ccEmails: Yup.string(),
    email: Yup.string().email().required(),
    firstName: Yup.string(),
    lastName: Yup.string(),
    phoneNumber: Yup.string().nullable(),
    phoneNumber_areaCode: Yup.string().nullable(),
    phoneNumber_base: Yup.string().nullable(),
    preferredLocale: Yup.string(),
    permissionTypes: Yup.array().of(Yup.string()).nullable(),
    pictureUrl: Yup.string().nullable(),
  }),
  linkedOwnerUid: Yup.string(),
});

export type OwnerFormSchemaType = Yup.InferType<typeof formSchema>;
